import { createStore, applyMiddleware, Middleware } from "redux";
import { rootReducer, AppState } from "./reducers";
import { initialUserState } from "./user/redux";
import { initialStateCollection } from "./collections/reducers";

export const createAppStore = () => {
	const middlewares: Middleware[] = [];

	if (process.env.NODE_ENV === 'development') {
		middlewares.push(require("redux-logger").default);
	}

	const store = createStore(rootReducer, getCachedState(), applyMiddleware(
		...middlewares
	));

	store.subscribe(() => {
		localStorage.setItem("cached", JSON.stringify(store.getState()));
	});

	return store;
}

const getCachedState = (): AppState => {
	const cache = localStorage.getItem("cached");
	let state: AppState = {
		currentUser: initialUserState,
		calendarBooks: {},
		collections: initialStateCollection
	}

	if (cache) {
		const cachedState: AppState = JSON.parse(cache);

		if (cachedState.currentUser) {
			state = {
				...state,
				currentUser: {
					...state.currentUser,
					...cachedState.currentUser
				}
			};
		}

		if (cachedState.calendarBooks) {
			state = {
				...state,
				calendarBooks: cachedState.calendarBooks
			}
		}

		if (cachedState.collections) {
			state = {
				...state,
				collections: cachedState.collections
			}
		}
	}

	return state;
};